<template>
  <div class="exam-result">
    <div class="exam-bg-img" :style="{backgroundImage: `url(${imageUrl})`}">
      <div class="result-box">
        <div class="cm-name">{{page.batchName}}</div>
        <div class="cm-title">成绩评定表</div>
        <div class="st-name">{{page.examineeName}}</div>
        <div class="st-ticket">准考证号：{{page.admissionTicketNo}}</div>
        <div class="st-ticket">专业等级：{{page.specialtyName}} ({{page.gradeName}})</div>
        <div class="tab-box">
          <table class="tab-details">
            <thead>
            <tr>
              <th class="nr-1">考核内容</th>
              <th class="nr-2">成绩</th>
              <th class="nr-3">评语</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, i) in tableList" :key="i">
              <td>
                <span class="className">{{ item.dimensionName }}</span>
              </td>
              <td style="text-align: center">
                <span>{{ item.dimensionValue }}</span>
              </td>
              <td>
                <span>{{ item.remarkContent }}</span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="result" :style="{backgroundImage: `url(${resultBgUrl})`}">
          <div class="res-evaluate">{{page.remarkContent}}</div>
          <div class="res-status">{{page.evaluateResult}}</div>
        </div>
        <div class="box-end">
          <div class="st-seal">
            <img style="width: 100%;height: 100%" src="../../static/images/certificate/img-seal.png" />
          </div>
          <div class="st-sign">故宫博物院</div>
          <div class="time">{{ page.updateTime ? getPartTime(page.updateTime) : '' }}</div>
        </div>
        <!-- <div class="foot">
          <div class="seal">
            <img v-if="this.page.isItemRemark === 0" style="width: 86px" src="../../static/images/examResult/img_z.png" alt="">
            <img v-else-if="this.page.isItemRemark === 1" style="width: 150px" src="../../static/images/examResult/img_lk@2x.png" alt="">
            <p v-if="this.page.updateTime">{{ getPartTime(this.page.updateTime) }}</p>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import imageUrl from '../../static/images/examResult/img_cjbk@2x.png'
import resultBgUrl from '../../static/images/examResult/img-pingjia@2x.png'

export default {
  data () {
    return {
      imageUrl,
      resultBgUrl,
      tableList: [
        {
          dimensionName: '音乐音乐音乐音乐音乐音乐',
          dimensionValue: '音乐音乐音乐音乐音乐音乐音乐',
          remarkContent: '音乐音乐音乐音乐音乐音乐'
        }
      ],
      page: {},
      evaluateExamId: this.$route.query.evaluateExamId
    }
  },
  async created () {
    await this.getdetail();
    let evaluateExamId = this.$route.query.evaluateExamId
    console.log(evaluateExamId)
  },
  methods: {
    async getdetail () {
      // let evaluateExamId = this.$route.query.evaluateExamId
      // console.log(evaluateExamId)
      let from = await this.$HTTP.ApiExamResult.getresultDetail(this.$route.query.evaluateExamId)
      // let from = {data: {dimensionList: this.tableList}}
      this.page = from.data
      this.tableList = this.page.dimensionList
      console.log(this.page)
    },
    getPartTime (val) {
      // let ti = val.split(' ');
      let timearr = val.replace(" ", ":").replace(/:/g, "-").split("-");
      let timestr = timearr[0] + "年" + Number(timearr[1]) + "月" + timearr[2] + "日";
      // console.log(4444,val)
      return timestr;
    }
  }
}
</script>

<style lang="less" scoped>
  .exam-result {
    width: 100vw;
    height: 100%;
    background-color: #FBFAFA;
    font-family: 'SourceHanSerifCN-Regular';
  }
  .exam-bg-img {
    margin: 38px/2 40px/2;
    background-color: #FFFDFC;
    border: 1px/2 solid #E1C199;
    border-radius: 16px/2;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    -moz-background-size: 100% 100%;
  }

  .result-box {
    margin: 25px/2 20px/2 17px/2;
    border: 14px/2 solid #BC3019;
  }

  .tab-box {
    text-align: center;
    width: 277px;
    /*min-height: 75px;*/
    border: 1px solid #967525;
    border-radius: 8px/2;
    margin: 40px/2 auto;
  }

  .tab-details {
    width: 277px;
    /*min-height: 125px;*/
    border-radius: 4px;
    margin: 0 auto;
    border-collapse: collapse;
    overflow: hidden;
    padding: 1px 0 0 1px;

    thead {
      tr {
        height: 20px;
      }
    }

    th {
      font-size: 20px/2;
      font-weight: normal;
      color: #967525;
    }

    td {
      font-size: 20px/2;
      text-align: left;
      height: 35px;

      span {
        max-width: 194px;
        font-weight: normal;
        color: #967525;
        padding: 0 6px;
        word-break: break-all;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .className {
        max-width: 194px;
        font-weight: normal;
        color: #967525;
        padding: 0 6px;
        word-break: break-all;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .nr-1 {
      width: 92px;
      padding: 7px/2 22px/2;
    }

    .nr-2 {
      width: 62px;
      padding: 7px/2 22px/2;
    }
    
    .nr-3 {
      padding: 7px/2 22px/2;
    }
  }

  table, table tr th, table tr td {
    border: 1px solid #967525;
  }

  .cm-name {
    margin: 53px/2 38px/2 0;
    font-size: 40px/2;
    font-family: 'SourceHanSerifCN-Bold';
    font-weight: bold;
    line-height: 57px/2;
    text-align: center;
    color: #B21D1E;
  }

.cm-title {
  margin: 8px/2 38px/2 0;
  font-size: 32px/2;
  font-family: 'SourceHanSerifCN-Bold';
  font-weight: bold;
  line-height: 46px/2;
  text-align: center;
  color: #B21D1E;
}

.st-name {
  margin: 34px/2 38px/2 0;
  font-size: 48px/2;
  font-family: 'SourceHanSerifCN-Bold';
  font-weight: bold;
  line-height: 69px/2;
  color: #77573A;
  text-decoration: underline;
  text-align: center;
}

.st-ticket {
  margin: 10px/2 38px/2 0;
  font-size: 22px/2;
  
  font-weight: 400;
  line-height: 30px/2;
  text-align: center;
  color: #675651;
}

.box-end {
  position: relative;
  margin: 32px/2 38px/2 54px/2;
  height: 139px/2;

  .st-seal {
    position: absolute;
    top: 0;
    right: 0;
    width: 129px/2;
    height: 129px/2;
  }

  .st-sign {
    position: absolute;
    top: 45px/2;
    right: 0;
    height: 30px/2;
    font-size: 22px/2;
    font-family: Songti SC;
    font-weight: 900;
    line-height: 32px/2;
    color: #1A294A;
  }

  .time {
    position: absolute;
    top: 78px/2;
    right: 0;
    height: 28px/2;
    font-size: 20px/2;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 26px/2;
    color: #1A294A;
  }
}

.result {
  position: relative;
  min-height: 132px/2;
  // margin: 33px/2 38px/2 0;
  // border: 1px solid #967525;
  // border-radius: 8px/2;
  width: 277px;
    /*min-height: 75px;*/
  border: 1px solid #967525;
  border-radius: 8px/2;
  margin: 40px/2 auto;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;

  .res-evaluate {
    padding: 30px/2 16px/2 24px/2;
    font-size: 28px/2;
    font-family: Source Han Serif CN;
    font-weight: bold;
    line-height: 38px/2;
    color: #BC3019;
  }

  .res-status {
    position: absolute;
    right: 0;
    top: 0;
    width: 106px/2;
    height: 30px/2;
    background: #77573A;
    border-radius: 0px 8px/2 0px 18px/2;
    font-size: 22px/2;
    font-family: Songti SC;
    font-weight: bold;
    line-height: 29px/2;
    text-align: center;
    color: #FFFFFF;
  }
}
</style>
